import { HttpServiceBase } from './http-service-base';

export class AccountActionService extends HttpServiceBase {
  constructor(...rest) {
    super(...rest);
  }

  get(id) {
    return new Promise((resolve, reject) => {
      this.http.get(`v1/accountactions/${id}`)
        .then(data => JSON.parse(data.response))
        .then(response => resolve(response))
        .catch(e => reject(e));
    });
  }

  /**
   * Skapar en engångsnyckel för att logga in i en annan area.
   *
   * Utan mål blir det en LoginAs-nyckel, som gamla Control och Eval löser in.
   * Med target 'control' blir det en LoginControl-nyckel för nya Control, som
   * bara går att lösa in där — och som servern bara skapar för den som har
   * Control eller Finance hos kunden.
   */
  create(target) {
    const url = target ? `/v1/accountactions?target=${encodeURIComponent(target)}` : '/v1/accountactions';
    return new Promise((resolve, reject) => {
      this.http.post(url, {})
        .then(data => JSON.parse(data.response))
        .then(response => resolve(response))
        .catch(e => reject(e));
    });
  }

  /**
   * Växlar nyckeln från Mina ansökningar i nya Control mot en JWT. Nyckeln
   * går bara att lösa in en gång.
   */
  redeemWeb(key) {
    return this.http.post('/v1/accountactions/web', { key })
      .then(data => JSON.parse(data.response));
  }
}
